<script lang="ts">
import { defineComponent } from 'vue';
import { AisRefinementList } from 'vue-instantsearch/vue3/es';
// Directives
import dropdown from '@vue-directives/dropdown';

export default defineComponent({
  components: {
    AisRefinementList,
  },
  directives: {
    dropdown,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    attribute: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isActive: false,
    };
  },
});
</script>
<template>
  <div v-dropdown class="dropdown group relative">
    <button
      aria-expanded="false"
      class="dropdown-trigger relative flex w-full items-center justify-between border-b border-solid border-current py-3 text-base/7 text-menzies-blue-900"
      type="button"
    >
      {{ label }}
      <svg ref="chevron" class="ml-3" viewBox="0 0 16 16" height="16" width="16" fill="none">
        <path
          d="M2 5L8.16086 10.6869C8.35239 10.8637 8.64761 10.8637 8.83914 10.6869L15 5"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    </button>

    <ais-refinement-list
      :attribute="attribute"
      :limit="100"
      :sort-by="['name:asc']"
      :class-names="{
        'ais-RefinementList':
          'absolute top-full left-0 z-[1] hidden w-max max-w-176 min-w-full bg-white group-[.open]:block',
        'ais-RefinementList-count': 'hidden',
        'ais-RefinementList-list': 'space-y-1 py-2',
        'ais-RefinementList-item--selected': 'bg-menzies-yellow-300',
        'ais-RefinementList-label': 'block px-4 text-base/7.5',
        'ais-RefinementList-checkbox': 'mr-3',
      }"
    />
  </div>
</template>
